import styled, { css } from 'styled-components';
import MuiAlert from '@material-ui/lab/Alert';
import { get } from 'lodash-es';

const Alert = styled(MuiAlert)`
  && {
    ${({ theme: { color }, severity }) => {
      const mainColor = get(color, severity, 'default');
      return css`
        align-items: center;
        background-color: ${color.white_500};
        box-shadow: 0px 8.14286px 16.2857px rgba(0, 0, 0, 0.05);
        border-radius: 2px;
        color: ${color.gray_700};
        display: flex;
        position: relative;
        width: 100%;

        &::before {
          background: ${mainColor};
          border-bottom-left-radius: 2px;
          border-top-left-radius: 2px;
          content: '';
          left: 0;
          height: 100%;
          position: absolute;
          top: 0;
          width: 8px;
        }

        .MuiAlert-message {
          ${({ theme: { font } }) => font.mainFont()};
          align-items: center;
          display: flex;
          font-size: 14px;
          line-height: 18px;
          justify-content: center;
        }

        .MuiAlert-icon {
          margin-right: 10px;
        }

        .MuiAlert-action button svg > path {
          fill: #bac2cb;
        }
      `;
    }}
  }
`;

export { Alert };
